import { ReactComponent as IconView } from '../assets/img/icons/common/IconView.svg';
import { ReactComponent as TableView } from '../assets/img/icons/common/TableView.svg';

export const restaurantsColumns = [
  {
    label: 'Number',
    value: 'number',
    mobile: true,
  },
  {
    label: 'Name',
    value: 'name',
    mobile: true,
  },
  {
    label: 'Kitchen Locations',
    value: 'kitchenLocations',
  },
  {
    label: 'State',
    value: 'state',
  },
  {
    label: 'City',
    value: 'city',
  },
  {
    label: 'Address',
    value: 'address',
  },
  {
    label: 'Postal Code',
    value: 'postalCode',
  },
  {
    label: 'PC',
    value: 'pc',
  },
  {
    label: 'Tablets',
    value: 'tablets',
  },
  {
    label: 'Business Hours',
    value: 'workingHours',
  },
  {
    label: 'Status',
    value: 'status',
  },
  {
    label: '',
    mobile: true,
  },
];

export const restaurantsSortOptions = [
  {
    label: 'Number',
    value: 'number',
  },
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Status',
    value: 'status',
  },
];

export const restaurantViewColumns = [
  {
    Icon: <TableView />,
    value: 'table',
  },
  {
    Icon: <IconView />,
    value: 'icon',
  },
];

export const restaurantStatusColors = {
  normal: '#17B61F',
  warning: '#DBB91D',
  error: '#DD0031',
};

export const KITCHEN_LOCATIONS = {
  BREADING: 'BREADING',
  FRYER: 'FRYER',
  CONVEYOR: 'CONVEYOR',
  HOT_HOLDING: 'HOT_HOLDING',
  MERCO_HOT_HOLDING: 'MERCO_HOT_HOLDING',
  PRS: 'PRS',
  ENTREE_CHUTES: 'ENTREE_CHUTES',
  SCHEDULED_PRODUCTION: 'SCHEDULED_PRODUCTION',
};

export const kitchenLocationOptions = [
  {
    label: 'Breading',
    value: KITCHEN_LOCATIONS.BREADING,
  },
  {
    label: 'Fryer',
    value: KITCHEN_LOCATIONS.FRYER,
  },
  {
    label: 'Conveyor',
    value: KITCHEN_LOCATIONS.CONVEYOR,
  },
  {
    label: 'Hot Holding',
    value: KITCHEN_LOCATIONS.HOT_HOLDING,
  },
  {
    label: 'Merco Hot Holding',
    value: KITCHEN_LOCATIONS.MERCO_HOT_HOLDING,
  },
  {
    label: 'PRS',
    value: KITCHEN_LOCATIONS.PRS,
  },
  {
    label: 'Entree Chutes',
    value: KITCHEN_LOCATIONS.ENTREE_CHUTES,
  },
  {
    label: 'Scheduled Production',
    value: KITCHEN_LOCATIONS.SCHEDULED_PRODUCTION,
  },
];
